import React, { useEffect, useCallback, useState} from 'react';
import {setCreatingNewPack} from 'actions/index.js';
import PacksSelector from './PacksSelector.js';
import NewPackFlow from './NewPackFlow.js';
import {connect} from 'react-redux';
import '../../Packs.scss';

const PacksComponent = ({setCreatingNewPack, sequencerEngine}) => { 
    return (
        <div className="packs-component">
          <div
            onClick={() => setCreatingNewPack(true)}
            className="new-pack-btn">
            Create a New Pack
          </div>
          <PacksSelector sequencerEngine={sequencerEngine}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setCreatingNewPack: (x) => dispatch(setCreatingNewPack(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PacksComponent);
